import React from "react";
import { useQuoteContext } from "../../../context-api/quote-context";
import { Link } from "react-router-dom";
import { useNavContext } from "../../../context-api/nav-context";
import { numBathsData } from "../utils/numBathsData";

const QuestSeven = () => {
  const { numBathroomsClick } = useQuoteContext();
  const { closeNavbarMenu } = useNavContext();
  return (
    <section
      className="questions-section section-wrapper"
      onMouseOver={closeNavbarMenu}
    >
      <div className="question-header">
        <h1 className="quote-question-title">Bathrooms Do You Have</h1>
      </div>
      <div className="question-card-section">
        {numBathsData.map((item, index) => {
          const { title, image } = item;
          return (
            <Link
              key={index}
              to="/question-eight"
              onClick={() => numBathroomsClick(index + 1)}
            >
              <div className="question-card">
                <div className="question-card-img">
                  <img src={image} alt={title} />
                </div>
                <div className="question-card-text">
                  <h5 className="subtitle">{title}</h5>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default QuestSeven;
